export {
  PaginationControls,
  type PaginationControlsProps,
} from "./PaginationControls";
